<div
    class="badge"
    [class.header]="headerStyle"
    [routerLink]="['/admin', 'iam', 'organizations', 'id', globalSearchOrganization?.tenantId]"
    fxLayout="row"
    fxLayoutAlign="start center"
>
    <!-- session icon -->
    <mat-icon svgIcon="c-customer"></mat-icon>

    <div fxFlex class="info" fxLayout="column">
        <span class="content" [attr.title]="globalSearchOrganization.name | ceCustomerPrivacy: 'org'">
            {{ globalSearchOrganization.name | ceCustomerPrivacy: 'org' }}
        </span>
        <span i18n="Organization badge|Badge header">Organization</span>
    </div>
</div>
